package br.com.texeratx.boardgametimeapp.ui.screens.expansions.model

data class ExpansionUI(
    val id: Long,
    val name: String,
    val imageUrl: String?
)
